import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from 'semantic-ui-react'
import { createMechandiseItem } from '../../actions'
import { useEvent } from '../../hooks/useEvent'
import MerchandiseDetails from './merchandiseDetails'
import { CustomLoader } from '../../../commonComponents/formComponents/loader'
import { SAVE_ITEM_CDS } from '../../api/apiEvents'
import { AddBtn } from '../../../commonComponents/AddBtn'
import AccordionInvoice from '@commonComponents/accordion/AccordianInvoice'

 const  MerchandiseLineItems = ({
  invoiceId,
  isFormEnabled, 
  invoiceItemIndex,
  fieldPattern,
  validateError,
  initItemsTabValidationCDS,
}) =>{

  const dispatch=useDispatch()
  const lineItems = useSelector((state) => state.InvoicesReducer.invoice.invoiceList[invoiceId]?.merchandiseIds) || []

  const { isLoading,saveForm }=useEvent("invoice",true)
 
  const getMerchandiseLineItemId=useCallback(async()=>{
       const response=await saveForm({"merchandise": {"": {"invoiceId": invoiceId } }},true,SAVE_ITEM_CDS)
          if(response){
            let merchandiseId =Object.keys(response.invoice.merchandise)[0]
            console.log({merchandiseId})
            let payload = response.invoice.merchandise[merchandiseId]
            let invoiceHeader = response.invoice.invoiceHeader
            let [,value] = Object.entries(response.invoice.invoiceList)[0]
            let [,header] = Object.entries(value)[0]
            dispatch(createMechandiseItem(invoiceId,payload,{invoiceHeader,header}))
            dispatch(initItemsTabValidationCDS())     
          }
  }      ,[dispatch,saveForm,createMechandiseItem,invoiceId])
  
  return (
  <React.Fragment>

    {
     lineItems.length > 0 &&
    <AccordionInvoice
     initialiState={{[lineItems?.[0]]:true}} 
     keyName={"toggleLineItems"} 
     invoiceId={invoiceId}
     expandTitle={"OPEN_ALL_ITEMS"}
     collapseTitle={"CLOSE_ALL_ITEMS"}
     >
    {
    lineItems?.map((item, index) => (
      <MerchandiseDetails
         id={item}
         key={item}
         invoiceId={invoiceId}
         merchandiseId={item}
         counter={index + 1}
         isFormEnabled={isFormEnabled}
         invoiceItemIndex={invoiceItemIndex}
         fieldPattern={fieldPattern}
         validateError={validateError}
         initItemsTabValidationCDS={initItemsTabValidationCDS}
      />
    ))
 }
    </AccordionInvoice>
    }
  {isLoading && <CustomLoader />}
     <AddBtn
    style={{ marginTop: '10px' }}
    onClick={getMerchandiseLineItemId}
    id={`addMerch-${invoiceId}`}
    iconClass=""
    text="Add Line Item"
    >
  </AddBtn>
   
  </React.Fragment>
  )
  
}
export default React.memo(MerchandiseLineItems)
